export default __webpack_public_path__ + "static/media/18.54ec6e47.jpg";